const responseCode = {
  Success: 200,
  ErrSystem: 4,
  NotFound: 6,
}

export default responseCode
